export const Condition = {
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_EQUALS: 'GREATER_THAN_EQUALS',
  EQUALS: 'EQUALS',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_EQUALS: 'LESS_THAN_EQUALS',
};
export const ConditionArray = [
  {
    value: 'gt',
    name: 'alertsNew.conditions.GREATER_THAN',
  },
  {
    value: 'gte',
    name: 'alertsNew.conditions.GREATER_THAN_EQUALS',
  },
  {
    value: 'eq',
    name: 'alertsNew.conditions.EQUALS',
  },
  {
    value: 'lt',
    name: 'alertsNew.conditions.LESS_THAN',
  },
  {
    value: 'lte',
    name: 'alertsNew.conditions.LESS_THAN_EQUALS',
  },
];
